import React, { useEffect, useState } from 'react';
import axios from 'axios';
import translations from '../../../translations';

const MoneyGiftForm = ({ id, onSaved }) => {
  const [bankName, setBankName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [receiverName, setReceiverName] = useState('');
  const [loading, setLoading] = useState(false);
  const [existing, setExisting] = useState(false);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/moneygifts/${id}`)
      .then(res => {
        if (res.data) {
          setBankName(res.data.bank_name || '');
          setAccountNumber(res.data.account_number || '');
          setReceiverName(res.data.receiver_name || '');
          setExisting(true);
        }
      })
      .catch(() => setExisting(false));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      card_id: id,
      bank_name: bankName,
      account_number: accountNumber,
      receiver_name: receiverName,
    };

    try {
      if (existing) {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/moneygifts/${id}`, payload);
      } else {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/moneygifts`, payload);
      }
      if (onSaved) onSaved();
    } catch (err) {
      console.error('Error saving bank info:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-lg">
      <div>
        <label className="block text-sm font-medium text-gray-700">{t.bankNameLabel}</label>
        <input
          type="text"
          value={bankName}
          onChange={(e) => setBankName(e.target.value)}
          placeholder={t.bankNamePlaceholder}
          className="w-full border px-3 py-2 rounded"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">{t.accountNumberLabel}</label>
        <input
          type="text"
          value={accountNumber}
          onChange={(e) => setAccountNumber(e.target.value)}
          placeholder={t.accountNumberPlaceholder}
          className="w-full border px-3 py-2 rounded"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">{t.receiverNameLabel}</label>
        <input
          type="text"
          value={receiverName}
          onChange={(e) => setReceiverName(e.target.value)}
          placeholder={t.receiverNamePlaceholder}
          className="w-full border px-3 py-2 rounded"
          required
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        {loading ? t.saving : existing ? t.update : t.save}
      </button>
    </form>
  );
};

export default MoneyGiftForm;
